import React from 'react';
import { Popover, Tooltip } from 'antd';
import UseBktGrid from '../UseBktGrid';
import { getMeta } from './ScenarioCompareDataView';
import { NestedLink, InfoIcon, InfoToolTipList } from './styles';

export const popupLink = (
  title, data, dataTypeOptions, gridConfigForData,
) => !data.content || !data.content[0]
  ? '0 items'
  : (
    <Popover
      title={title}
      placement="left"
      overlayClassName="DCRPScenarioComparePopOver"
      content={(
        <UseBktGrid
          data={data.content}
          meta={getMeta(data.type, dataTypeOptions)}
          config={gridConfigForData}
          onNested={(titleInner, dataInner) => popupLink(
            titleInner, dataInner, dataTypeOptions, gridConfigForData,
          )}
          height="20vh"
        />
      )}
    >
      <NestedLink
        {...(data.useSimilarMatches) ? { color: 'clientPrimary' } : { color: 'clientSecondary' }}
      >
        {`${data.content.length} ${data.content.length === 1 ? 'item' : 'items'}`}
      </NestedLink>
    </Popover>
  );

export const infoLink = data => (data.length > 0)
  ? (
    <Tooltip title={(
      <InfoToolTipList>
        {
          data.map(line => (
            <li>{line.text}</li>
          ))
        }
      </InfoToolTipList>
    )}
    >
      <InfoIcon />
    </Tooltip>
  )
  : null;
